import { ImageStyleFields, type ImageStyle } from './ImageStyleFields';

/**
 * The code as it will be printed, with the controls that change it attached underneath, so what they act on
 * needs no label to say so.
 */
export function QrArtwork({
  idPrefix,
  imageUrl,
  alt,
  loadingLabel,
  transparentHint,
  style,
  onStyleChange,
}: {
  idPrefix: string;
  /** Null while the bytes are still being fetched. */
  imageUrl: string | null;
  alt: string;
  loadingLabel: string;
  transparentHint: string;
  style: ImageStyle;
  onStyleChange: (style: ImageStyle) => void;
}) {
  return (
    <div className="qr-widget">
      <div className="qr-widget__image">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={alt}
            // A transparent code on a white card looks exactly like a white one; the chequerboard says
            // see-through the way every image editor does.
            className={style.background === 'Transparent' ? 'is-transparent' : undefined}
          />
        ) : (
          <div className="qr-placeholder">
            <i className="pi pi-spin pi-spinner" aria-hidden="true" />
            {loadingLabel}
          </div>
        )}
      </div>

      <ImageStyleFields idPrefix={idPrefix} value={style} onChange={onStyleChange} />

      {/* A transparent code is the one choice in the strip whose consequence is outside the application, so
          it says so where it is made - rather than in a tooltip nobody hovers. */}
      {style.background === 'Transparent' && (
        <p className="qr-widget__hint">
          <i className="pi pi-info-circle" aria-hidden="true" />
          {transparentHint}
        </p>
      )}
    </div>
  );
}
